import React from 'react';
import SectionHeader from './ui/SectionHeader';

const PILLARS = [
  {
    icon: '📵',
    problem: 'Privacy should be default',
    why: 'Queer conversations — especially when you’re dating or hooking up — shouldn’t end up on someone else’s camera roll.',
    solution: 'Screenshots and screen recordings are blocked across StrapIn. Always on. No toggle.',
    flag: 'Always on',
  },
  {
    icon: '✓',
    problem: 'Not everyone can be publicly out',
    why: 'Closeted and private users still deserve trust — without being forced into public visibility.',
    solution:
      'Public verification (visible badge) or discreet verification (private check — trust without putting verification on display).',
    flag: 'Trust',
  },
  {
    icon: '📍',
    problem: 'Nearby shouldn’t mean exposed',
    why: 'Exact location can feel dangerous — at home, at work, in your city.',
    solution: 'You see approximate distance only — never a precise pin on a map.',
    flag: 'Discovery',
  },
  {
    icon: '🚫',
    problem: 'Your data is not the business',
    why: 'Many apps monetize attention and data. That’s not our model.',
    solution: 'We do not sell your data. Subscription-first. Privacy-first.',
    flag: 'Non-negotiable',
  },
  {
    icon: '📁',
    problem: 'Sharing on your terms',
    why: 'Intimacy shouldn’t mean permanent access.',
    solution: 'Private albums with timed or one-time access — revoke anytime. Strapin Plus unlocks up to 10 albums.',
    flag: 'Your rules',
  },
  {
    icon: '🛡️',
    problem: 'Safety shouldn’t be a checkbox',
    why: 'A generic “report” button doesn’t help when something actually feels wrong.',
    solution:
      'Structured safety reports from profile or chat — real categories, human review, optional block in one step.',
    flag: 'Safety',
  },
];

function WhatWeDoDifferently() {
  return (
    <section className="relative overflow-hidden bg-charcoal py-24 md:py-32">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_50%_40%_at_0%_50%,rgba(216,27,96,0.08),transparent)]" aria-hidden />

      <div className="site-container relative">
        <SectionHeader
          tag="How we’re different"
          title="Privacy and trust"
          titleAccent="built in — not bolted on"
          description="Every choice answers one question: why does this exist for queer people who date and connect here?"
        />

        <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
          {PILLARS.map((item, index) => (
            <article key={item.problem} className="glass-card-hover group relative flex flex-col p-6 md:p-7">
              <span className="absolute right-5 top-5 text-4xl font-black text-white/[0.04]">
                {String(index + 1).padStart(2, '0')}
              </span>
              <div className="feature-icon-box mb-4">{item.icon}</div>
              <h3 className="mb-2 text-lg font-bold text-white">{item.problem}</h3>
              <p className="mb-3 text-sm leading-relaxed text-silver/90">
                <span className="font-semibold text-mist">Why it matters: </span>
                {item.why}
              </p>
              <p className="mt-auto text-sm leading-relaxed text-silver">
                <span className="font-semibold text-primary">StrapIn: </span>
                {item.solution}
              </p>
              <span className="mt-4 inline-block w-fit rounded-full border border-primary/25 bg-primary/10 px-3 py-1 text-xs font-bold text-primary">
                {item.flag}
              </span>
            </article>
          ))}
        </div>

        <div className="mt-10 rounded-3xl border border-primary/25 bg-gradient-to-br from-primary/15 to-transparent p-8 md:p-10">
          <p className="mx-auto max-w-3xl text-center text-base leading-relaxed text-silver md:text-lg">
            Built by people who were tired of apps that didn&apos;t protect the community — every decision
            starts with queer safety and privacy, whether you&apos;re here to date, hook up, or just
            connect.
          </p>
        </div>
      </div>
    </section>
  );
}

export default WhatWeDoDifferently;
